import React, { useEffect, useRef, useState } from "react"

import classNames from "gpages/utils/classnames"
import mobileMenuLogo from "@images/ggg/mobile-menu-logo.png"
import mobileMenuClose from "@images/ggg/mobile-menu-close.png"

import * as styles from "./nav.module.scss"
const { getActiveSection } = require("./activeSection.cjs")

const items = [
  { id: "ticket", label: "票务信息", en: "Ticket" },
  { id: "intro", label: "活动详情", en: "Intro" },
  { id: "cast", label: "参演阵容", en: "Cast" },
  { id: "gifts", label: "伴手礼", en: "Gifts" },
  { id: "host", label: "主办信息", en: "Host" },
]

const Nav = () => {
  const [activeId, setActiveId] = useState(null)
  const [isContainerVisible, setIsContainerVisible] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const menuButtonRef = useRef(null)
  const closeButtonRef = useRef(null)

  useEffect(() => {
    let frameId
    const update = () => {
      cancelAnimationFrame(frameId)
      frameId = requestAnimationFrame(() => {
        const hero = document.getElementById("hero")
        const sections = items
          .map(({ id }) => document.getElementById(id))
          .filter(Boolean)
          .map((section) => ({ id: section.id, top: section.offsetTop }))
        const marker = window.scrollY + window.innerHeight * 0.35
        // The final section may be too short to reach the regular marker before scrolling ends.
        const isNearPageBottom =
          window.scrollY + window.innerHeight * 1.5 >=
          document.documentElement.scrollHeight

        setIsContainerVisible(!hero || hero.getBoundingClientRect().bottom <= 0)
        setActiveId(getActiveSection(sections, marker, isNearPageBottom))
      })
    }

    update()
    window.addEventListener("scroll", update, { passive: true })
    window.addEventListener("resize", update)
    return () => {
      cancelAnimationFrame(frameId)
      window.removeEventListener("scroll", update)
      window.removeEventListener("resize", update)
    }
  }, [])

  useEffect(() => {
    if (!isMenuOpen) return undefined

    const previousOverflow = document.body.style.overflow
    const handleKeyDown = (event) => {
      if (event.key === "Escape") setIsMenuOpen(false)
    }
    const handleResize = () => {
      if (window.innerWidth >= 1000) setIsMenuOpen(false)
    }

    document.body.style.overflow = "hidden"
    window.addEventListener("keydown", handleKeyDown)
    window.addEventListener("resize", handleResize)
    requestAnimationFrame(() => closeButtonRef.current?.focus())

    return () => {
      document.body.style.overflow = previousOverflow
      window.removeEventListener("keydown", handleKeyDown)
      window.removeEventListener("resize", handleResize)
    }
  }, [isMenuOpen])

  const scrollToSection = (id) => {
    setIsMenuOpen(false)
    document
      .getElementById(id)
      ?.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  const closeMenu = () => {
    setIsMenuOpen(false)
    requestAnimationFrame(() => menuButtonRef.current?.focus())
  }

  return (
    <>
      <div
        className={classNames(
          styles.navContainer,
          isContainerVisible && styles.navContainerVisible
        )}
      >
        <div className={styles.navBackdrop} aria-hidden="true" />
        <nav className={styles.nav} aria-label="页面导航">
          {items.map((item) => (
            <button
              key={item.id}
              type="button"
              className={classNames(
                styles.item,
                activeId === item.id && styles.itemActive
              )}
              aria-pressed={activeId === item.id}
              onClick={() => scrollToSection(item.id)}
            >
              <span>{item.label}</span>
              <span className={styles.en}>{item.en}</span>
            </button>
          ))}
        </nav>

        <div className={styles.mobileNav}>
          <span className={styles.mobileNavLogo}>
            <img src={mobileMenuLogo} alt="GGG 游戏节奏联欢夜" />
          </span>
          <button
            ref={menuButtonRef}
            type="button"
            className={styles.mobileMenuButton}
            aria-controls="mobile-page-menu"
            aria-expanded={isMenuOpen}
            onClick={() => setIsMenuOpen(true)}
          >
            <span>菜单</span>
            <span className={styles.en}>Menu</span>
          </button>
        </div>
      </div>

      <div
        id="mobile-page-menu"
        className={classNames(
          styles.mobileMenuOverlay,
          isMenuOpen && styles.mobileMenuOverlayOpen
        )}
        aria-hidden={!isMenuOpen}
      >
        <button
          ref={closeButtonRef}
          type="button"
          className={styles.mobileMenuClose}
          aria-label="关闭菜单"
          tabIndex={isMenuOpen ? 0 : -1}
          onClick={closeMenu}
        >
          <img src={mobileMenuClose} alt="" />
        </button>
        <nav className={styles.mobileMenuItems} aria-label="手机版页面导航">
          {items.map((item) => (
            <button
              key={item.id}
              type="button"
              className={styles.mobileMenuItem}
              tabIndex={isMenuOpen ? 0 : -1}
              onClick={() => scrollToSection(item.id)}
            >
              <span>{item.label}</span>
              <span className={styles.en}>{item.en}</span>
            </button>
          ))}
        </nav>
        <img
          src={mobileMenuLogo}
          alt="GGG 游戏节奏联欢夜"
          className={styles.mobileMenuBrand}
        />
      </div>
    </>
  )
}

export default Nav
